import React from "react";
import DocumentButton from "./DocumentButton";

function DocumentType(props) {
  return (
    <div class="mt-4">
      <h2>{props.name}</h2>
      <hr/>
      {props.data.map((item, index) => {return(
        <div class="mx-5">
          <div align = "left" class="div_docus">
            <DocumentButton label={item.label} semester={item.semester} data={item.data}></DocumentButton>
          </div>
          <div class="spacer"></div>
          <div align = "right" class="div_docu right_docu">
            <span>{item.date}</span>
          </div>
          <hr class="lightLine"/>
        </div>
      )})}
    </div>
  );
}

export default DocumentType;